import { Record } from "../../types";
import MaterialIcon from "../../components/MaterialIcon";
import { RefObject, useState } from "react";
import ConfirmationModal from "../../components/ConfirmationModal";

interface RecordTableProps {
  records: Record[];
  loading: boolean;
  removeRecord: (id: number) => void;
  handleEdit: (id: number) => void;
  recordTable: RefObject<HTMLTableElement>;
}

function RecordTable({
  records,
  loading,
  removeRecord,
  handleEdit,
  recordTable,
}: RecordTableProps) {
  let [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  let [recordToDelete, setRecordToDelete] = useState<number | null>(null);

  return (
    <>
      <table className="text-grayscale-100 bg-grayscale-900 w-full border-collapse overflow-hidden rounded-lg text-center text-sm md:text-base">
        <caption className="font-small text-small text-blu-100 mt-2 caption-bottom text-xs">
          Days worked during current pay period.
        </caption>
        <colgroup>
          <col className="col-min-width w-1 whitespace-nowrap"></col>
          <col className="col-min-width hidden w-1 whitespace-nowrap md:table-column"></col>
          <col className="col-min-width hidden w-1 whitespace-nowrap md:table-column"></col>
          <col></col>
          <col className="col-min-width w-1 whitespace-nowrap"></col>
        </colgroup>
        <thead className="from-blu-1000 to-blu-400 bg-gradient-to-tr">
          <tr>
            <th className="p-1 md:p-2" scope="col">
              Date
            </th>
            <th className="hidden p-1 py-1 md:table-cell md:p-2" scope="col">
              RSD
            </th>
            <th className="hidden p-1 md:table-cell md:p-2" scope="col">
              Code
            </th>
            <th className="p-1 md:p-2" scope="col">
              Justification
            </th>
            <th className="p-1 md:p-2" scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td className="table-label p-4" colSpan={4}>
                <div className="flex justify-center">
                  <MaterialIcon
                    icon="progress_activity"
                    className="animate-spin text-white"
                  />
                </div>
              </td>
            </tr>
          ) : records.length === 0 ? (
            <tr>
              <td className="table-label p-4" colSpan={4}>
                No events recorded.
              </td>
            </tr>
          ) : (
            records.map((record, index) => {
              let d = new Date(record.date);
              return (
                <tr
                  key={record.id}
                  className="border-b-grayscale-900 hover:bg-grayscale-900 group border-b-2 last:border-0"
                >
                  {/* <td>{ e.date.getDate() }/{ e.date.getMonth() + 1 }/{ e.date.getFullYear() }</td> */}
                  <td className="md:px-1 md:py-2 ">
                    <div>
                      <p className="md:hidden">
                        {d.getDate()}/{d.getMonth() + 1}
                      </p>
                      <p className="hidden md:block">{record.date}</p>
                      <p className="text-nowrap md:hidden">
                        {record.amount} RSD
                      </p>
                    </div>
                  </td>
                  <td className="hidden p-1 md:table-cell md:px-1 md:py-2 ">
                    {record.amount}
                  </td>
                  <td className="hidden p-1 md:table-cell md:px-1 md:py-2">
                    {record.code}
                  </td>
                  <td className="p-1 text-left md:px-1 md:py-2">
                    <span className="font-semibold md:font-normal">
                      {record.description}
                    </span>
                    <span className="text-blu-100 md:hidden">
                      {" "}
                      (Code {record.code})
                    </span>
                  </td>
                  <td className="p-2 opacity-100 transition-opacity group-hover:opacity-100 md:flex-row md:px-1 md:py-2 md:opacity-0">
                    <div className="flex h-full flex-col content-center gap-4 md:flex-row md:gap-2">
                      <button
                        className="hover:text-blu-400 flex flex-grow items-baseline transition-colors"
                        onClick={() => handleEdit(index)}
                      >
                        <MaterialIcon icon="edit" />
                      </button>
                      <button
                        className="hover:text-blu-400 flex flex-grow items-baseline transition-colors"
                        onClick={() => {
                          setRecordToDelete(record.id);
                          setDeleteModalOpen(true);
                        }}
                      >
                        <MaterialIcon icon="delete" />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      <table
        ref={recordTable}
        className="hidden"
        style={{
          border: "solid 1px black",
          borderCollapse: "collapse",
          background: "white",
          color: "black",
          textAlign: "center",
        }}
      >
        <thead>
          <tr>
            <th style={{ border: "solid 1px black" }}>Date</th>
            <th style={{ border: "solid 1px black" }}>RSD</th>
            <th style={{ border: "solid 1px black" }}>Code</th>
            <th style={{ border: "solid 1px black" }}>Justification</th>
          </tr>
        </thead>
        <tbody>
          {records.map((record, index) => {
            return (
              <tr>
                <td style={{ border: "solid 1px black" }}>{record.date}</td>
                <td style={{ border: "solid 1px black" }}>{record.amount}</td>
                <td style={{ border: "solid 1px black" }}>{record.code}</td>
                <td style={{ border: "solid 1px black" }}>
                  {record.description}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <ConfirmationModal
        title="Delete record"
        message="Are you sure?"
        open={deleteModalOpen}
        closeModal={() => setDeleteModalOpen(false)}
        onConfirm={async () => {
          if (recordToDelete === null) {
            return;
          }
          removeRecord(recordToDelete);
          setRecordToDelete(null);
          setDeleteModalOpen(false);
        }}
        onCancel={() => setDeleteModalOpen(false)}
      />
    </>
  );
}

export default RecordTable;
